/* sap-away-title.js (Sydney Aero Parts): rotates the tab title while the visitor is on another tab. Config: C. */
(function(w,d){try{
var C={wait:6e3,every:3e3,max:30},S=w.Shopify||{};
if(S.designMode||/\/checkouts?(\/|$)/.test(location.pathname))return;
var orig,t1,t2,on=0,n=0,p='',m=d.querySelector('meta[property="og:type"]');
if(m&&m.content=='product'){m=d.querySelector('meta[property="og:title"]');p=(m&&m.content||'').split(' | ')[0].trim();
if(p.length>C.max){p=p.slice(0,C.max+1);var k=p.lastIndexOf(' ');p=(k>0?p.slice(0,k):p.slice(0,C.max)).replace(/[\s,.:;&-]+$/,'')}}
function list(){var a=[];if(n>0)a.push('Your cart is still here',n+(n==1?' item':' items')+' in your cart');
if(p)a.push('Still looking at the '+p+'?');a.push('Want to jump back in?','Pick up where you left off');return a}
function stop(){clearTimeout(t1);clearInterval(t2);t1=t2=0;if(on){on=0;d.title=orig}}
d.addEventListener('visibilitychange',function(){try{
if(!d.hidden)return stop();if(t1)return;orig=d.title;n=0;var i=0;
w.fetch&&fetch((S.routes&&S.routes.root||'/')+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){n=c.item_count|0}).catch(function(){});
t1=setTimeout(function(){function f(){if(!d.hidden)return;var a=list();on=1;d.title=a[i++%a.length]}f();t2=setInterval(f,C.every)},C.wait)
}catch(e){}})
}catch(e){}})(window,document);
